import { EnvironmentConfigShape, checkStdProcessEnvs } from "@iotv/iotv-v3-types";
import { resolvedEnvironmentVariables } from "./resolvedEnvironmentVariables";
/** Must be imported as type, or will through errors in UI as net, child_process and constant Node objects are not available in browser runtime */
import type { ComparisonOperator, TreatMissingData } from 'aws-cdk-lib/aws-cloudwatch'
import { parentHostedZoneName } from '../../../domainAccountConfig'
import { defaultAWSCDKConfig } from "./defaultAWSCDKConfig";
const { default_region, region, accountId, projectCode, appName, stage } = resolvedEnvironmentVariables

const undefinedEnvVars = Object.entries({ default_region, accountId, projectCode, appName, stage })
    .reduce((a, [ ck, cv ]) => {
        if (!(typeof cv === 'string')) a.push(ck)
        return a
    }, [] as string[])
if (undefinedEnvVars.length > 0) {
    throw new Error(`The following environment variables are not set ${ undefinedEnvVars.join(', ') }`)
}

const TLD = parentHostedZoneName
const mailFromSubDomain = 'robots'
const shortProjectCode = projectCode.substring(0, 4)
const getInternalAccountDomain = () => `${ stage }.${ shortProjectCode }.${ TLD }`

export const config: EnvironmentConfigShape = {
    aws: defaultAWSCDKConfig,
    iotv: {

    },
    /** WIP 2024 03 adding map specific keys, currently they are imported but incorrectly used in UI */
    google: {
        // LSC=DEVELOPMENT-2025
        gcp: {
            //lsc-development-2025 lsc-apps
            clientId: '946745731000-cl4nr6qpop3paultvvgfr465qln203i5.apps.googleusercontent.com',
            apiKey: 'AIzaSyBUtFsDjgzwnTj_-0QNdJbahfbp0a0g4Fg',
        },
    },
    internalAccountDomain: getInternalAccountDomain(),
    mailFromSubDomain: 'robots',
    parentAccountDomain: parentHostedZoneName,
    BaseData: {
        Region: {
            names: [ 'Africa', 'Asia Pacific', 'Europe', 'Middle East', 'North America', 'South America' ],
        }
    },

    apps: {
        webUI: {
            ventureName: shortProjectCode,
            showProgrammeSets: true,
            useSpecializedViews: true,
            initialRedirect: null,
            groupedObjectTypes: {

            },
        },
    },
}


